
import Vue from "vue";
import { focus, ValidationService } from "@fkui/logic";

import { getNewState } from "@/store";

export default Vue.extend({
    name: "FkTeknisktFel",
    async mounted() {
        await this.$nextTick();
        const element = this.$refs.felsidaHeading;
        if (element instanceof HTMLElement) {
            focus(element);
        }
        this.clearState();
    },
    methods: {
        clearState() {
            window.onpopstate = null;
            this.$store.replaceState(getNewState());
            ValidationService.clearAllStates();
        },
    },
});
